import React, { useEffect, useState } from 'react';
import Head from 'src/general/components/Head/Head';
import { useTermsOfService } from 'src/lib/contentful/hooks/useGetTermsOfService';
import { useTranslation } from 'src/lib/translations';
import { TermsContent, TermsContentProps } from 'src/modules/TermsPageContent';

const TermsOfServicePage = () => {
  const { t } = useTranslation();
  const { state, title, sections } = useTermsOfService();
  const [termsData, setTermsData] = useState<TermsContentProps>();

  useEffect(() => {
    if (state.value === 'SUCCESS') {
      setTermsData({
        sections,
        title,
      });
    }
  }, [sections, state.value, title, state?.context?.error]);

  return (
    <>
      <Head
        description={t('Head.TermsPage.Description')}
        subtitle={t('Head.TermsPage.Subtitle')}
        title={t('Head.TermsPage.Title')}
      />
      <TermsContent sections={termsData?.sections} title={termsData?.title} />
    </>
  );
};
export default TermsOfServicePage;
